<template lang="html">
  <header class="header">
    <h1>
      <a href="/">
        <main-logo></main-logo>
      </a>
    </h1>
    <p>
      <a href="tel:704-643-5550" class="tele">(704) 643-5550</a>
      <a href="#contact" class="btn">contact us</a>
    </p>
  </header>
</template>

<script>
  import Logo from '@/components/Logo'

  export default {
    components: {
      'main-logo': Logo
    },
    name: 'main-header',
    data () {
      return {

      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .header {
    grid-column: 1 / 2;
    grid-row: 1 / 2;

    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 1rem;

    background-color: rgba($dark-blue, 0.6);
    color: $white;
    z-index: 20;
    h1 {
      margin: 0;
    }

    @include breakpoint($md) {
      padding: 0 7.500rem;
    }

  }

  .tele {
    display: none;
    margin-right: 2rem;
    color: $light-blue;
    font-family: $montserrat;
    font-size: 1rem;
    letter-spacing: 1px;
    text-decoration: none;
    @include breakpoint($md) {
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue